import { useState, useRef } from "react";
import logoMainForm from "../../assets/images/logo-main-form.png";
import { MessageForm } from "./widgets/MessageForm";
import { renewPassword } from "../../api/user/userService";
import { setStatusFormAlert } from "../../hooks/AlertsForm";
import { useSpring, animated } from "@react-spring/web";
import { getValueFromInputElement } from "../../utils/inputRefHandlers";
import whiteCheck from "../../assets/svg/white_check.svg";


export function RenewPassword(props) {
  const { token } = props;
  const [hasProcessingInformation, setHasProcessingInformation] = useState(false);
  const inputRefs = useRef({ password: "", confirm_password: "" });
  const [formRequestStatus, setFormRequestStatus] = useState({
    typeAlert: "",
    message: ""
  });
  const timeToRemoveMessage = useRef(0);
  const [passwordSuccess, setPassworduccess] = useState(false);
  const propsUseSpring = useSpring({
    from: { width: "0%" },
    to: { width: passwordSuccess ? "100%" : "0%" },
    config: { duration: 1e4 }
  });
  const setNewPassword = (e) => {
    e.preventDefault();
    const password = inputRefs.current.password;
    const confirmPassword = inputRefs.current.confirm_password;
    if (password === confirmPassword) {
      setHasProcessingInformation(true);
      renewPassword(password, token).then((data) => {
        setHasProcessingInformation(false);
        let statusHttp = data["statusHttp"];
        switch (statusHttp) {
          case 0:
            setStatusFormAlert(
              data,
              "alert-danger",
              setFormRequestStatus,
              timeToRemoveMessage
            );
            break;
          case 400:
            setStatusFormAlert(
              data,
              "alert-danger",
              setFormRequestStatus,
              timeToRemoveMessage
            );
            break;
          case 404:
            setStatusFormAlert(
              data,
              "alert-danger",
              setFormRequestStatus,
              timeToRemoveMessage
            );
            break;
          case 200:
            setPassworduccess(true);
            setTimeout(() => {
              window.location.href = "/";
            }, 1e4);
            break;
        }
      });
    } else {
      let responseError = {
        message: "Ops! As senhas digitadas s\xE3o diferentes. Por favor, insira senhas iguais."
      };
      setStatusFormAlert(
        responseError,
        "alert-danger",
        setFormRequestStatus,
        timeToRemoveMessage
      );
    }
  };

  return (
    <div className="re-create-password-px-5 d-flex align-items-center justify-content-center">
      <div className="re-create-password-area-form">
        <span className="re-create-password-container-main-icon-form">
          <img
            src={logoMainForm}
            alt="Ícone de parceiros"
            className="re-create-password-main-icon-form"
          />
        </span>
        <br />
        {passwordSuccess === false && (
          <MessageForm
            formRequestStatus={formRequestStatus}
            hasProcessingInformation={hasProcessingInformation}
          />
        )}
        <br />
        {passwordSuccess === true ? (
              <>
                <div className="d-flex justify-content-center">
                  <div className="w-50">
                    <img src={whiteCheck} className="img-fluid" alt="" />
                  </div>
                </div>

                <div
                  className="alert alert-success  text-center fs-6 mt-5"
                  role="alert"
                  style={{ padding: "7px" }}
                >
                  Senha redefinida com sucesso! Aguarde um momento, você será
                  redirecionado para a página de login.
                </div>

                <div
                  style={{
                    marginTop: "3%",
                    width: "100%",

                    height: "5px",
                    background: "transparent",
                  }}
                >
                  <animated.div
                    style={{
                      ...propsUseSpring,
                      height: "100%",
                      background: "#FFF",
                      borderRadius: "50px",
                    }}
                  />
                </div>
              </>
            ) 
            : (
        <>
        <span className="re-create-password-form-title">Criar Nova Senha</span>
        <div>
          <form className="w-100" onSubmit={setNewPassword}>
            <div
              className="re-create-password-field-form-to-fill"
              data-validate="Enter password"
            >
              <input
                type="password"
                className="re-create-password-input-form"
                name="password"
                placeholder="Nova Senha"
                required
                onChange={(e) => {getValueFromInputElement(e, inputRefs);}}
              />
              <span
                className="re-create-password-icon-form-input"
                data-placeholder="&#128272;"
              ></span>
            </div>

            <div
              className="re-create-password-field-form-to-fill"
              data-validate="Enter password"
            >
              <input
                type="password"
                className="re-create-password-input-form"
                name="confirm_password"
                placeholder="Confirmar Senha"
                required
                onChange={(e) => {getValueFromInputElement(e, inputRefs);}}
              />
              <span
                className="re-create-password-icon-form-input"
                data-placeholder="&#128272;"
              ></span>
            </div>

            <div className="re-create-password-container-btn-submit-form">
              <button className="re-create-password-btn-submit-form" type="submit">
                Redefinir Senha
              </button>
            </div>
            <hr />
          </form>
        </div>

        </>

            )
            }
      </div>
    </div>
  );
}
